const VixCloseRecruit = function(el) {
    document.addEventListener('click', e => {
        let target = e.target;

        if(!target.closest('.title_recruit') && el.classList.contains('on')) {
            el.classList.remove('on');
        }
    });
};
export default VixCloseRecruit;